<template>
  <div class="m-3 py-3 text-gray-800 dark:text-dark-text bg-white dark:bg-dark-800">
    <WarningText v-if="isAiReview(entryId).value" :text="AIWARNTEXT" />
    <div class="w-full">
      <ReviewDetailViewer :entryId="entryId" :entryType="entryType" :index="index" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import ReviewDetailViewer from '@presentation/components/ReviewPost/children/ReviewDetailViewer.vue'
import WarningText from '@presentation/components/Text/WarningText.vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useReviewPostPresenter } from '@/presentation/composables/reviewPost/useReviewPostPresenter'
import timestampToDate from '@/util/date/timestampToDate'

export default defineComponent({
  components: {
    WarningText,
    ReviewDetailViewer
  },
  props: {
    entryId: {
      type: String,
      required: true
    },
    entryType: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  setup(props, ctx) {
    const { displayLanguage } = useConfigStatePresenter()
    const { initState, getEntryDetail, isAiReview } = useReviewPostPresenter()

    const reviewId = computed(() => getEntryDetail(props.entryId).value.reviewId)
    const reviewDate = computed(() => getEntryDetail(props.entryId).value.reviewDate)

    const AIWARNTEXT =
      displayLanguage.value === 'Japanese' ? 'このレビューはAIが行いました。' : 'This review was performed by AI.'

    return {
      timestampToDate,
      initState,
      isAiReview,
      reviewId,
      reviewDate,
      AIWARNTEXT
    }
  }
})
</script>

<style lang="postcss" scoped>
.panel-top {
  padding: 0.7em 1em 0.7em 1em;
}

.panel-bottom {
  padding: 0em 0em 0em 0em;
}

.no-select {
  user-select: none;
}
</style>
